import { useNavigate } from 'react-router-dom';
import { Clock, ShieldCheck, ArrowRight, Check, X } from 'lucide-react';
import { PORTAL_ROUTES } from 'utils/constants';
import { pendingForms } from 'components/Profile/Consent/helper';
import {
  profileSeps,
  getNextIncompleteStep,
  getNumberOfCompletedStep,
  pageHeadings
} from './helper';
import Item from './Item';
import { Button } from 'components/Button';
import { useOutletContext } from 'react-router-dom';
import { useState } from 'react';

const Dashboard = () => {
  const { completion, sectionData }: any = useOutletContext();
  const navigate = useNavigate();
  const [alertDismissed, setAlertDismissed] = useState(false);

  const nextStep = getNextIncompleteStep(completion)
  const totalCompeledSteps = getNumberOfCompletedStep(completion)
  const pendingTreatmentConsents = pendingForms(sectionData?.treatmentConsents).length

  let { heading, id: nextStepId } = nextStep || {}
  let { pageHeading, pageSubHeading, className, btnTitle, info, icon: Icon } = pageHeadings(nextStepId)
  const showAlert = !alertDismissed && totalCompeledSteps == 5
  
  return (
    <div className="flex-1 overflow-y-auto p-6 lg:p-8">
      {showAlert && (
        <div className="flex items-center justify-between gap-3 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 mb-5">
          <div className="flex items-center gap-2.5">
            <Check size={15} className="text-green-500 shrink-0" strokeWidth={2.5} />
            <p className="text-sm font-medium text-secondary-700">Saved. Your information is up to date.</p>
          </div>
          <button
            onClick={() => setAlertDismissed(true)}
            className="text-secondary-400 hover:text-secondary-600 transition-colors shrink-0"
            aria-label="Dismiss"
          >
            <X size={15} />
          </button>
        </div>
      )}

      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3 mb-6">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-secondary-900 leading-tight">{pageHeading}</h1>
          <p className="mt-1 text-sm text-secondary-400">{pageSubHeading}</p>
        </div>

        <div className="lg:text-right shrink-0">
          <p className="text-sm font-medium text-secondary-600">
            {totalCompeledSteps} of 5 forms complete
          </p>

          <div className="mt-2 h-1.5 w-full lg:w-48 rounded-full bg-gray-200 overflow-hidden">
            <div
              className="h-full rounded-full bg-green-600 transition-all duration-500"
              style={{ width: `${(totalCompeledSteps / 5) * 100}%` }}
            />
          </div>
        </div>
      </div>

      {totalCompeledSteps < 5 &&
        <div className={`flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 border rounded-2xl px-5 lg:px-6 py-5 mb-6 ${className.bg}`}>
          <div className="flex items-start gap-4">
            <div className={`flex items-center justify-center w-11 h-11 rounded-xl shrink-0 ${className.icon}`}>
              <Icon size={22} />
            </div>

            <div>
              <p className="font-semibold text-secondary-900">{heading}</p>
              <p className="text-sm text-secondary-400 mt-0.5">{info}</p>

              {totalCompeledSteps == 0 &&
                <div className="flex flex-wrap items-center gap-2 mt-3">
                  <span className="inline-flex items-center gap-1.5 text-xs text-secondary-500 bg-white border border-gray-200 rounded-full px-3 py-1">
                    <Clock size={12} /> About 6 minutes
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-xs text-secondary-500 bg-white border border-gray-200 rounded-full px-3 py-1">
                    <ShieldCheck size={12} /> Private &amp; secure
                  </span>
                </div>
              }
            </div>
          </div>

          <Button
            title={btnTitle}
            onClick={() => navigate(`${PORTAL_ROUTES.PROFILE}/${nextStepId}`)}
            variant={'tertiary'}
            icon={<ArrowRight size={16} />}
            className={"flex items-center gap-2 justify-center self-start"}
          />
        </div>
      }

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {profileSeps.map((step, index) =>
          <Item
            key={index}
            item={step}
            completion={completion}
            pendingCount={step.id === 'consent' ? pendingTreatmentConsents : 0}
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
